import React from 'react';
import MySubscription from '../../components/MySubscription';

export type MySubscriptionPageProps = {
  isWebview?: boolean;
};

export const MySubscriptionPage = ({ isWebview = false }: MySubscriptionPageProps) => {
  return <MySubscription isWebview={isWebview} />;
};

export default MySubscriptionPage;
